export default __webpack_public_path__ + "static/media/cc2.f01505ae.svg";